<ion-header>
  <ion-toolbar color="dark">
    <ion-title>Log Viewer (dev)</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="toggleShowRaw()"
        [color]="showRaw ? 'warning' : 'medium'"
        title="Affiche le contenu non-anonymisé (contient des PII)"
      >
        <ion-icon [name]="showRaw ? 'eye' : 'eye-off'" slot="icon-only"></ion-icon>
      </ion-button>
      <ion-button (click)="close()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar color="dark">
    <ion-searchbar
      class="log-viewer__search"
      placeholder="Rechercher dans les logs…"
      [value]="search"
      (ionInput)="onSearchChange($event)"
      debounce="120"
    ></ion-searchbar>
  </ion-toolbar>
  <ion-toolbar color="dark">
    <div class="log-viewer__filters">
      <ion-chip
        [outline]="levelFilter !== 'all'"
        color="primary"
        (click)="setLevelFilter('all')"
      >All ({{ allEntries.length }})</ion-chip>
      <ion-chip
        [outline]="levelFilter !== 'error'"
        color="danger"
        (click)="setLevelFilter('error')"
      >Error</ion-chip>
      <ion-chip
        [outline]="levelFilter !== 'warn'"
        color="warning"
        (click)="setLevelFilter('warn')"
      >Warn</ion-chip>
      <ion-chip
        [outline]="levelFilter !== 'log'"
        (click)="setLevelFilter('log')"
      >Log</ion-chip>
      <ion-chip
        [outline]="levelFilter !== 'info'"
        color="tertiary"
        (click)="setLevelFilter('info')"
      >Info</ion-chip>
      <ion-chip
        [outline]="levelFilter !== 'debug'"
        color="medium"
        (click)="setLevelFilter('debug')"
      >Debug</ion-chip>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="log-viewer__content">
  <div
    *ngIf="filteredEntries.length === 0"
    class="log-viewer__empty"
  >
    Aucun log à afficher.
  </div>

  <div
    *ngFor="let entry of filteredEntries; trackBy: trackById"
    class="log-entry"
    [class]="levelClass(entry.level)"
  >
    <div class="log-entry__meta">
      <span class="log-entry__time">{{ formatTime(entry.timestamp) }}</span>
      <span class="log-entry__level">{{ entry.level }}</span>
    </div>
    <pre class="log-entry__message">{{ displayMessage(entry) }}</pre>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar color="dark">
    <div class="log-viewer__send">
      <ion-button
        expand="block"
        fill="solid"
        color="success"
        [disabled]="sending || allEntries.length === 0"
        (click)="sendToSupport()"
      >
        <ion-icon name="cloud-upload-outline" slot="start"></ion-icon>
        {{ sending ? "Envoi en cours…" : "Envoyer au support" }}
      </ion-button>
    </div>
    <div class="log-viewer__actions">
      <ion-button size="small" expand="block" fill="solid" color="primary" (click)="copyAll()">
        <ion-icon name="copy-outline" slot="start"></ion-icon>
        Copier tout
      </ion-button>
      <ion-button size="small" expand="block" fill="outline" color="primary" (click)="copyVisible()">
        Copier vue
      </ion-button>
      <ion-button size="small" expand="block" fill="outline" color="danger" (click)="clear()">
        <ion-icon name="trash-outline" slot="start"></ion-icon>
        Vider
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
